var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"body"},[_c('div',{staticClass:"header"},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('div',{staticClass:"outer"},[_c('router-view')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }